import { useLazyQuery } from '@apollo/client';
import { useAuth } from '@contexts/AuthContext';
import { useProId } from '@contexts/ProIdContext';
import { DOWNLOAD_ALL_FILES_BY_TALENT, DOWNLOAD_ALL_FILES_BY_TALENT_UPERCUT } from '@gql/file';

export const useDownloadAllFilesByTalent = (options: any = {}) => {
    const { isUpercut } = useAuth();
    const { isProIdRequired } = useProId();

    const isUpercutFlow = isUpercut && !isProIdRequired;
    const queryToUse = isUpercutFlow ? DOWNLOAD_ALL_FILES_BY_TALENT_UPERCUT : DOWNLOAD_ALL_FILES_BY_TALENT;

    const [downloadAllFilesByTalent, queryState] = useLazyQuery(queryToUse, {
        fetchPolicy: 'network-only',
        ...options,
    });

    return {
        downloadAllFilesByTalent,
        ...queryState,
        queryName: isUpercutFlow ? 'DownloadAllFilesByTalentUpercut' : 'DownloadAllFilesByTalent',
        resultField: isUpercutFlow ? 'downloadAllFilesByTalentUpercut' : 'downloadAllFilesByTalent',
        isUpercutFlow,
    };
};
